import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { instance } from "../../Const/ApiHeader";
import {
  ADD_VEHICLE,
  ALL_MANUFACTURER,
  GET_SINGLE_VEHICLE,
  UPDATE_VEHICLE,
} from "../../Const/ApiConst";
import { NO_IMAGE_PLACEHOLDER } from "./vehicleFormConstants";

export function useVehicleForm(mode) {
  const navigate = useNavigate();
  const params = useParams();
  const isEdit = mode === "update";

  const [saveVehicleLoading, setSaveVehicleLoading] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [vehicleColors, setVehicleColors] = useState([]);
  const [colors, setColors] = useState("");
  const [vehicleName, setVehicleName] = useState("");
  const [vehicleCategory, setVehicleCategory] = useState("Hatchback");
  const [engine, setEngine] = useState("");
  const [maxPower, setMaxPower] = useState("");
  const [maxTorque, setMaxTorque] = useState("");
  const [groundClearence, setGroundClearence] = useState("");
  const [turningRadius, setTurningRadius] = useState("");
  const [fuelTank, setFuelTank] = useState("");
  const [wheelbase, setWheelbase] = useState("");
  const [bootspace, setBootspace] = useState("");
  const [diemention, setDiemention] = useState("");
  const [manufacturerData, setManufacturerData] = useState([]);
  const [activeVariantTab, setActiveVariantTab] = useState("0");
  const [tablist, setTablist] = useState([]);
  const [tabItemName, setTabItemName] = useState("");
  const [currentVariantList, setCurrentVariantList] = useState([]);
  const [currentFeatureAction, setCurrentFeatureAction] = useState("");
  const [vehicleImage, setVehicleImage] = useState(NO_IMAGE_PLACEHOLDER);
  const [imageType, setImageType] = useState("Colors");
  const [imageName, setImageName] = useState("");
  const [manufacturerType, setManufacturerType] = useState("");
  const [isLoading, setIsLoading] = useState(isEdit);
  const [Milage, setMilage] = useState("");
  const [typreSize, setTypreSize] = useState("");
  const [vehicleTitle, setVehicleTitle] = useState("");
  const [engineType, setEngineType] = useState("ICE");
  const [chargingOptions, setChargingOptions] = useState("");
  const [regenMods, setRegenMods] = useState("");
  const [batteryCooling, setBatteryCooling] = useState("");
  const [batteryType, setBatteryType] = useState("");
  const [batteryVoltage, setBatteryVoltage] = useState("");
  const [motorType, setMotorType] = useState("");
  const [totalSystemMaxPower, setTotalSystemMaxPower] = useState("");
  const [frontSuspension, setFrontSuspension] = useState("");
  const [rearSuspension, setRearSuspension] = useState("");
  const [driveTrain, setDriveTrain] = useState("");
  const [accelaration, setAccelaration] = useState("");
  const [hybridType, setHybridType] = useState("");
  const [batterySafetyRating, setBatterySafetyRating] = useState("");
  const [totalSystemMaxTorque, setTotalSystemMaxTorque] = useState("");
  const [motorPower, setMotorPower] = useState("");
  const [motorTorque, setMotorTorque] = useState("");
  const [chargingTime, setChargingTime] = useState("");
  const [lastUpdated, setLastUpdated] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [status, setStatus] = useState("Active");

  const applyVehicleData = (vehicle) => {
    if (!vehicle) return;
    setVehicleImage(vehicle.vehicleImage || NO_IMAGE_PLACEHOLDER);
    setManufacturerType(vehicle.manufacturerType || "");
    setVehicleName(vehicle.vehicle_name || "");
    setEngine(vehicle.engineCC || "");
    setMaxPower(vehicle.maxPower || "");
    setMaxTorque(vehicle.maxTorque || "");
    setGroundClearence(vehicle.groundClearence || "");
    setTurningRadius(vehicle.turningRadius || "");
    setFuelTank(vehicle.FuelTank || "");
    setWheelbase(vehicle.wheelBase || "");
    setBootspace(vehicle.bootspace || "");
    setDiemention(vehicle.dimention || "");
    setVehicleColors(vehicle.images || []);
    setMilage(vehicle.milage || "");
    setTypreSize(vehicle.tyreSize || "");
    setVehicleCategory(vehicle.vehicleCategory || "Hatchback");
    setVehicleTitle(vehicle.vehicleTitleText || "");
    setEngineType(vehicle.engineType || "ICE");
    setChargingOptions(vehicle.chargingOptions || "");
    setRegenMods(vehicle.regenMods || "");
    setBatteryCooling(vehicle.batteryCooling || "");
    setBatteryType(vehicle.batteryType || "");
    setBatteryVoltage(vehicle.batteryVoltage || "");
    setMotorType(vehicle.motorType || "");
    setTotalSystemMaxPower(vehicle.totalSystemMaxPower || "");
    setFrontSuspension(vehicle.frontSuspension || "");
    setRearSuspension(vehicle.rearSuspension || "");
    setDriveTrain(vehicle.driveTrain || "");
    setAccelaration(vehicle.accelaration || "");
    setHybridType(vehicle.hybridType || "");
    setBatterySafetyRating(vehicle.batterySafetyRating || "");
    setTotalSystemMaxTorque(vehicle.totalSystemMaxTorque || "");
    setMotorPower(vehicle.motorPower || "");
    setMotorTorque(vehicle.motorTorque || "");
    setChargingTime(vehicle.chargingTime || "");
    setStatus(vehicle.status || "Active");
    setLastUpdated(
      vehicle.lastUpdated
        ? moment(vehicle.lastUpdated).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD")
    );

    const variants = vehicle.variantList || [];
    const uniqueVariants = Array.from(
      new Set(variants.map((item) => item.variant))
    );
    setTablist(uniqueVariants);
    setCurrentVariantList(variants);
  };

  const loadVehicle = async () => {
    if (!params.id) return;
    setIsLoading(true);
    try {
      const response = await instance.post(GET_SINGLE_VEHICLE, { id: params.id });
      const vehicle = Array.isArray(response.data)
        ? response.data[0]
        : response.data;
      applyVehicleData(vehicle);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const loadManufacturers = async () => {
    try {
      const response = await instance.post(ALL_MANUFACTURER);
      const manufacturers = response.data?.data || [];
      setManufacturerData(manufacturers);
      if (!manufacturerType && manufacturers[0]?.manufacturerName) {
        setManufacturerType(manufacturers[0].manufacturerName);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadManufacturers();
    if (params.id) {
      loadVehicle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const removeImageItem = (index) => {
    setVehicleColors((current) => current.filter((_, i) => i !== index));
  };

  const addColorAction = () => {
    if (!colors.trim() || !imageName?.fileName) return;
    setVehicleColors((current) => [
      ...current,
      {
        imageType,
        name: colors,
        imagePreview: imageName.fileName,
      },
    ]);
    setImageName("");
    setColors("");
  };

  const addTabItem = () => {
    if (!tabItemName.trim()) {
      alert("Enter variant name");
      return;
    }
    setTablist((current) => [...current, tabItemName.trim()]);
    setTabItemName("");
    setActiveVariantTab(String(tablist.length));
  };

  const deleteVariant = (index, variantName) => {
    setTablist((current) => current.filter((_, i) => i !== index));
    setCurrentVariantList((current) =>
      current.filter((item) => item.variant !== variantName)
    );
    setActiveVariantTab("0");
  };

  const renameVariant = (index, nextName) => {
    const trimmed = nextName.trim();
    if (!trimmed) {
      alert("Variant name cannot be empty");
      return false;
    }

    const previousName = tablist[index];
    if (!previousName || previousName === trimmed) {
      return true;
    }

    const duplicate = tablist.some(
      (name, i) => i !== index && name.toLowerCase() === trimmed.toLowerCase()
    );
    if (duplicate) {
      alert("A variant with this name already exists");
      return false;
    }

    setTablist((current) => {
      const nextTabs = [...current];
      nextTabs[index] = trimmed;
      return nextTabs;
    });
    setCurrentVariantList((list) =>
      list.map((item) =>
        item.variant === previousName ? { ...item, variant: trimmed } : item
      )
    );
    return true;
  };

  const deleteFeatureAction = (index) => {
    setCurrentVariantList((current) => current.filter((_, i) => i !== index));
  };

  const addTempVariantAction = (variantName) => {
    if (!currentFeatureAction.trim()) return;
    setCurrentVariantList((current) => [
      ...current,
      {
        feature: currentFeatureAction.trim(),
        variant: variantName,
        unavailable: false,
      },
    ]);
    setCurrentFeatureAction("");
  };

  const toggleFeatureUnavailable = (index) => {
    setCurrentVariantList((current) =>
      current.map((item, i) =>
        i === index
          ? { ...item, unavailable: !Boolean(item.unavailable) }
          : item
      )
    );
  };

  const reorderVariants = (fromIndex, toIndex) => {
    if (fromIndex === toIndex) return;

    setTablist((currentTabs) => {
      if (
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= currentTabs.length ||
        toIndex >= currentTabs.length
      ) {
        return currentTabs;
      }

      const nextTabs = [...currentTabs];
      const [moved] = nextTabs.splice(fromIndex, 1);
      nextTabs.splice(toIndex, 0, moved);

      setCurrentVariantList((currentList) => {
        const grouped = nextTabs.flatMap((name) =>
          currentList.filter((item) => item.variant === name)
        );
        const leftovers = currentList.filter(
          (item) => !nextTabs.includes(item.variant)
        );
        return [...grouped, ...leftovers];
      });

      setActiveVariantTab((active) => {
        const activeName = currentTabs[Number(active)];
        const nextIndex = nextTabs.indexOf(activeName);
        return String(nextIndex >= 0 ? nextIndex : 0);
      });

      return nextTabs;
    });
  };

  const reorderVariantFeatures = (variantName, fromIndex, toIndex) => {
    if (fromIndex === toIndex) return;

    setCurrentVariantList((current) => {
      const entries = current
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => item.variant === variantName);

      if (
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= entries.length ||
        toIndex >= entries.length
      ) {
        return current;
      }

      const reordered = [...entries];
      const [moved] = reordered.splice(fromIndex, 1);
      reordered.splice(toIndex, 0, moved);

      const slotIndices = entries.map(({ index }) => index);
      const next = [...current];
      reordered.forEach(({ item }, position) => {
        next[slotIndices[position]] = item;
      });
      return next;
    });
  };

  const buildPayload = () => ({
    id: params.id,
    manufacturerType,
    vehicleImage,
    vehicleName,
    vehicleTitle,
    engine,
    maxPower,
    maxTorque,
    groundClearence,
    turningRadius,
    fuelTank,
    wheelbase,
    bootspace,
    diemention,
    images: vehicleColors,
    variantList: currentVariantList,
    milage: Milage,
    tyreSize: typreSize,
    vehicleCategory,
    engineType,
    chargingOptions,
    regenMods,
    batteryCooling,
    batteryType,
    batteryVoltage,
    motorType,
    totalSystemMaxPower,
    totalSystemMaxTorque,
    frontSuspension,
    rearSuspension,
    driveTrain,
    accelaration,
    hybridType,
    batterySafetyRating,
    motorPower,
    motorTorque,
    chargingTime,
    lastUpdated,
    status,
  });

  const saveAction = async () => {
    const endpoint = isEdit ? UPDATE_VEHICLE : ADD_VEHICLE;
    try {
      setSaveError("");
      setSaveVehicleLoading(true);
      await instance.post(endpoint, buildPayload());
      navigate("/vehicles");
    } catch (error) {
      console.log(error);
      setSaveError("Failed to save vehicle. Please try again.");
    } finally {
      setSaveVehicleLoading(false);
    }
  };

  return {
    isEdit,
    isLoading,
    saveVehicleLoading,
    saveError,
    manufacturerData,
    vehicleImage,
    setVehicleImage,
    manufacturerType,
    setManufacturerType,
    vehicleName,
    setVehicleName,
    vehicleTitle,
    setVehicleTitle,
    vehicleCategory,
    setVehicleCategory,
    engineType,
    setEngineType,
    engine,
    setEngine,
    motorType,
    setMotorType,
    maxPower,
    setMaxPower,
    maxTorque,
    setMaxTorque,
    typreSize,
    setTypreSize,
    diemention,
    setDiemention,
    wheelbase,
    setWheelbase,
    bootspace,
    setBootspace,
    turningRadius,
    setTurningRadius,
    groundClearence,
    setGroundClearence,
    fuelTank,
    setFuelTank,
    Milage,
    setMilage,
    chargingOptions,
    setChargingOptions,
    frontSuspension,
    setFrontSuspension,
    rearSuspension,
    setRearSuspension,
    status,
    setStatus,
    lastUpdated,
    setLastUpdated,
    batteryType,
    setBatteryType,
    batteryCooling,
    setBatteryCooling,
    batterySafetyRating,
    setBatterySafetyRating,
    hybridType,
    setHybridType,
    batteryVoltage,
    setBatteryVoltage,
    motorPower,
    setMotorPower,
    motorTorque,
    setMotorTorque,
    totalSystemMaxPower,
    setTotalSystemMaxPower,
    totalSystemMaxTorque,
    setTotalSystemMaxTorque,
    vehicleColors,
    imageType,
    setImageType,
    colors,
    setColors,
    imageName,
    setImageName,
    removeImageItem,
    addColorAction,
    tablist,
    tabItemName,
    setTabItemName,
    addTabItem,
    activeVariantTab,
    setActiveVariantTab,
    deleteVariant,
    renameVariant,
    currentVariantList,
    currentFeatureAction,
    setCurrentFeatureAction,
    deleteFeatureAction,
    addTempVariantAction,
    toggleFeatureUnavailable,
    reorderVariants,
    reorderVariantFeatures,
    saveAction,
    navigate,
  };
}
